var _circle, _circle2, _mask, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25.5548,
    cy: 21.5631,
    r: 8.88195,
    stroke: "#808080",
    strokeWidth: 3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 25.5556,
    cy: 25.5556,
    r: 24.0556,
    stroke: "#808080",
    strokeWidth: 3
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-1_929_37440",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.2168 43.3538C9.61048 35.8246 16.9148 30.3467 25.5543 30.3467C34.1943 30.3467 41.4991 35.8253 43.8922 43.3553C39.2481 48.1387 32.7488 51.1108 25.5553 51.1108C18.361 51.1108 11.861 48.138 7.2168 43.3538Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.2168 43.3538L4.3578 42.4449L3.81397 44.1555L5.06422 45.4434L7.2168 43.3538ZM43.8922 43.3553L46.0446 45.4451L47.295 44.1573L46.7513 42.4467L43.8922 43.3553ZM10.0758 44.2627C12.0633 38.0111 18.1873 33.3467 25.5543 33.3467V27.3467C15.6424 27.3467 7.15767 33.6381 4.3578 42.4449L10.0758 44.2627ZM25.5543 33.3467C32.9218 33.3467 39.0461 38.0118 41.0332 44.264L46.7513 42.4467C43.952 33.6389 35.4668 27.3467 25.5543 27.3467V33.3467ZM41.7398 41.2656C37.6373 45.4911 31.9049 48.1108 25.5553 48.1108V54.1108C33.5927 54.1108 40.8589 50.7862 46.0446 45.4451L41.7398 41.2656ZM25.5553 48.1108C19.205 48.1108 13.472 45.4905 9.36938 41.2642L5.06422 45.4434C10.25 50.7855 17.517 54.1108 25.5553 54.1108V48.1108Z",
    fill: "#808080",
    mask: "url(#path-3-inside-1_929_37440)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/group.76a314644450e037361c8e4521e06d00.svg";
export { ForwardRef as ReactComponent };